import React from 'react';
import { Result } from 'antd';
import { useIntl } from 'react-intl';
import AccionaButton from '../../../../../../../../components/AccionaButton';
import PropTypes from 'prop-types';

const SuccessPage = ({ onBackToTemplates, title, subtitle }) => {
  const intl = useIntl();
  return (
    <Result
      status="success"
      title={title}
      subTitle={<p style={{ fontSize: '18px' }}>{subtitle}</p>}
      extra={
        <AccionaButton
          type="primary"
          onClick={onBackToTemplates}
          classIcon="fas fa-chevron-left"
          msg={intl.formatMessage({
            id: 'pages.quality.ocr.templates.successPage.button.goToList',
          })}
        />
      }
    />
  );
};

SuccessPage.propTypes = {
  onBackToTemplates: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node.isRequired,
};

export default SuccessPage;
